const config = {
    // API_BASE_URL: "http://localhost/bravodent_ci",
    API_BASE_URL: "https://dentalserver.online",

}


export default config;